import {
  BlindChannelCalibrateStateResponse,
  BlindFeatureTypeInternal,
  ChannelTypeInternal,
  DeviceConnectionState,
  MeasuredBy,
} from '../../../../data-access/gql-types/graphql';
import { FavouritePositions } from './base';

export type ChannelCoverType = {
  type: ChannelTypeInternal.Blind;
  groupType: ChannelTypeInternal;
  favouritePositionList: FavouritePositions;
  supportedBlindFeatures: BlindFeatureTypeInternal[];
  sensitivityAOK: number | null;
  measuredBy?: MeasuredBy;
};

export type ChannelCoverStateType = {
  usesCounter: number;
  movingParams: {
    predictedTimeInMs: number | null;
    slatsPredictedTimeInMs: number | null;
    targetPosition: number | null;
  };
  lavvaStateDirection?: string;
  lavvaStatePosition?: number;
  calibrateState?: BlindChannelCalibrateStateResponse;
  deviceConnectionState?: DeviceConnectionState;
  grantedUses?: number;
};

export enum CoverDirection {
  unknown = 0,
  stop = 1,
  open = 2,
  close = 3,
}

export enum CoverKindParam {
  Channel,
  Action,
}
